import React, { useState,useEffect } from "react";
import { FaEye, FaTimes, FaCalendar, FaTag, FaMapMarkerAlt, FaWrench, FaMoneyBillWave, FaImage, FaTools, FaClipboardList, FaExclamationTriangle, FaCheckCircle, FaClock } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import { useData } from "../../context/DataContext";
import { resolveMediaUrl } from "../../utils/mediaUrl";

function DeatailAset({id, data}) {
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const openDetailModal = () => setIsDetailModalOpen(true);
  const closeDetailModal = () => setIsDetailModalOpen(false);
  const {exgambar,monitoring,perawatan,getPerMon}=useData()

  const resolveAsetImageUrl = (file) => resolveMediaUrl(exgambar, file);
  // Mengambil data inventaris berdasarkan ID
  const getInventaris = (id) => {
    return data.find((item) => item.id === id);
  };
  const getPerawatan=(id)=>{
    return perawatan.filter((item) => item.inventaris_id === id);
  }

  const getMonitoring=(id)=>{
    return monitoring.filter((item) => item.inventaris_id === id);
  }

  React.useEffect(()=>{
    if (id && isDetailModalOpen) {
      getPerMon()
    }
  },[id, isDetailModalOpen])


  const inventaris = getInventaris(id);

  const backdropVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
    exit: { opacity: 0 },
  };

  const modalVariants = {
    hidden: {
      opacity: 0,
      scale: 0.9,
      y: 20,
    },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        duration: 0.4,
        ease: [0.25, 0.46, 0.45, 0.94],
      },
    },
    exit: {
      opacity: 0,
      scale: 0.9,
      y: 20,
      transition: {
        duration: 0.3,
        ease: "easeIn",
      },
    },
  };

  const headerVariants = {
    hidden: { opacity: 0, y: -10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { delay: 0.1, duration: 0.3 },
    },
  };

  const contentVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { delay: 0.2, duration: 0.3 },
    },
  };

  const closeButtonVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { delay: 0.1, duration: 0.3 },
    },
    hover: {
      scale: 1.1,
      rotate: 90,
      transition: { duration: 0.2 },
    },
  };

  // Format tanggal ke bahasa Indonesia
  const formatTanggal = (tanggal) => {
    if (!tanggal) return "-";
    const date = new Date(tanggal);
    return date.toLocaleDateString('id-ID', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  // Format mata uang Rupiah
  const formatRupiah = (angka) => {
    if (!angka) return "Rp 0";
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR'
    }).format(angka);
  };

  // Fungsi untuk mendapatkan status kondisi dengan warna
  const getStatusKondisi = (kondisi) => {
    switch (kondisi?.toLowerCase()) {
      case 'baik':
        return { 
          text: 'Baik', 
          color: 'text-green-700', 
          bg: 'bg-green-100', 
          icon: <FaCheckCircle className="text-green-600" /> 
        };
      case 'rusak ringan':
        return { 
          text: 'Rusak Ringan', 
          color: 'text-yellow-700', 
          bg: 'bg-yellow-100', 
          icon: <FaExclamationTriangle className="text-yellow-600" /> 
        };
      case 'rusak berat':
        return { 
          text: 'Rusak Berat', 
          color: 'text-red-700', 
          bg: 'bg-red-100', 
          icon: <FaExclamationTriangle className="text-red-600" /> 
        };
      default:
        return { 
          text: kondisi || 'Tidak Diketahui', 
          color: 'text-gray-700', 
          bg: 'bg-gray-100', 
          icon: <FaClock className="text-gray-600" /> 
        };
    }
  };

  // Fungsi untuk menampilkan data array dengan error handling
  const renderDataArray = (dataArray, emptyMessage) => {
    if (!Array.isArray(dataArray) || dataArray.length === 0) {
      return (
        <div className="text-center py-8">
          <div className="text-gray-400 text-4xl mb-3">
            <FaClipboardList />
          </div>
          <p className="text-gray-500 text-sm">{emptyMessage}</p>
        </div>
      );
    }
    return dataArray;
  };
  
  return (
    <>
      <button
        onClick={openDetailModal}
        className="text-blue-600 hover:text-blue-900 p-2 hover:bg-blue-50 rounded-lg transition-all duration-200"
        title="Lihat Detail"
      >
        <FaEye className="text-sm" />
      </button>

      {/* ==================== MODAL DETAIL ASET ==================== */}
      <AnimatePresence>
        {isDetailModalOpen && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
            variants={backdropVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            onClick={closeDetailModal}
          >
            <motion.div
              className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] flex flex-col"
              variants={modalVariants}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header Modal - Sticky */}
              <motion.div
                className="bg-primary text-white p-6 relative rounded-t-2xl flex-shrink-0"
                variants={headerVariants}
              >
                <motion.button
                  onClick={closeDetailModal}
                  className="absolute top-4 right-4 text-white hover:text-gray-200 p-2 rounded-full hover:bg-white hover:bg-opacity-20 transition-all duration-200 z-10"
                  variants={closeButtonVariants}
                  whileHover="hover"
                >
                  <FaTimes className="text-lg" />
                </motion.button>
                
                <h2 className="text-2xl font-bold mb-2">Detail Aset Inventaris</h2>
                <p className="text-white/80 text-sm">
                  Informasi lengkap aset inventaris
                </p>
              </motion.div>

              {/* Konten Modal - Scrollable */}
              <motion.div
                className="flex-1 overflow-y-auto p-6 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 hover:scrollbar-thumb-gray-400"
                variants={contentVariants}
                style={{ 
                  maxHeight: 'calc(90vh - 200px)',
                  scrollBehavior: 'smooth'
                }}
              >
                {inventaris ? (
                  <div className="space-y-6">
                    {/* Informasi Utama */}
                    <div className="bg-gray-50 rounded-xl p-5">
                      <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                        <FaTag className="mr-2 text-blue-600" />
                        Informasi Utama
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="space-y-3">
                          <div>
                            <label className="text-sm font-medium text-gray-600">Nama Aset</label>
                            <p className="text-gray-800 font-medium">{inventaris.desc || "-"}</p>
                          </div>
                          <div>
                            <label className="text-sm font-medium text-gray-600">Kode Aset</label>
                            <p className="text-gray-800 font-medium">
                              {inventaris.kode || "-"}
                            </p>
                          </div>
                          <div>
                            <label className="text-sm font-medium text-gray-600">Nomor Simkug</label>
                            <p className="text-gray-800 font-medium">
                              {inventaris.kode_sim || "-"}
                            </p>
                          </div>
                          <div>
                            <label className="text-sm font-medium text-gray-600">Kategori</label>
                            <p className="text-gray-800">{inventaris.kategori || "-"}</p>
                          </div>
                        </div>
                        <div className="space-y-3">
                          <div>
                            <label className="text-sm font-medium text-gray-600">Merk</label>
                            <p className="text-gray-800">{inventaris.merk || "-"}</p>
                          </div>
                          <div>
                            <label className="text-sm font-medium text-gray-600">Model/Tipe</label>
                            <p className="text-gray-800">{inventaris.model || inventaris.type || "-"}</p>
                          </div>
                          <div>
                            <label className="text-sm font-medium text-gray-600">Warna</label>
                            <p className="text-gray-800">{inventaris.color || "-"}</p>
                          </div>
                          <div>
                            <label className="text-sm font-medium text-gray-600">Spesifikasi</label>
                             <p className="text-gray-800 font-medium">
                              {inventaris.spec || "-"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Informasi Lokasi dan Penanggungjawab */}
                    <div className="bg-blue-50 rounded-xl p-5">
                      <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                        <FaMapMarkerAlt className="mr-2 text-blue-600" />
                        Lokasi / Gambar
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="space-y-3">
                          <div>
                            <label className="text-sm font-medium text-gray-600">Gedung</label>
                            <p className="text-gray-800">{inventaris.gedung_nama || "-"}</p>
                          </div>
                          <div>
                            <label className="text-sm font-medium text-gray-600">Ruangan</label>
                            <p className="text-gray-800">{inventaris.ruang || "-"}</p>
                          </div>
                        </div>
                        <div className="space-y-3">
                          <div>
                            <label className="text-sm font-medium text-gray-600 flex items-center mb-2">
                              <FaImage className="mr-2 text-blue-600" />
                              Gambar Aset
                            </label>
                            {resolveAsetImageUrl(inventaris.gambar) ? (
                              <PhotoProvider>
                                <div className="grid grid-cols-2 gap-2">
                                  <PhotoView src={resolveAsetImageUrl(inventaris.gambar)}>
                                    <div className="relative group cursor-pointer">
                                      <img
                                        src={resolveAsetImageUrl(inventaris.gambar)}
                                        alt={inventaris.desc || 'Gambar aset'}
                                        className="w-full h-24 object-cover rounded-lg border-2 border-gray-200 hover:border-blue-400 transition-all duration-200"
                                        onError={(e) => {
                                          e.currentTarget.style.display = 'none';
                                          const fallback = e.currentTarget.parentElement?.querySelector('[data-img-fallback]');
                                          if (fallback) fallback.classList.remove('hidden');
                                        }}
                                      />
                                      <div
                                        data-img-fallback
                                        className="hidden w-full h-24 rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 flex items-center justify-center text-xs text-gray-400"
                                      >
                                        Gambar tidak tersedia
                                      </div>
                                      <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 rounded-lg transition-all duration-200 flex items-center justify-center">
                                        <FaEye className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                                      </div>
                                    </div>
                                  </PhotoView>
                                </div>
                              </PhotoProvider>
                            ) : (
                              <div className="w-full h-24 rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 flex items-center justify-center text-xs text-gray-400">
                                Tidak ada gambar
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Informasi Finansial dan Tanggal */}
                    <div className="bg-green-50 rounded-xl p-5">
                      <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                        <FaMoneyBillWave className="mr-2 text-green-600" />
                        Informasi Finansial & Tanggal
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="space-y-3">
                          <div>
                            <label className="text-sm font-medium text-gray-600">Harga Perolehan</label>
                            <p className="text-gray-800 font-semibold text-green-700">
                              {formatRupiah(inventaris.harga || "-")}
                            </p>
                          </div>
                          <div>
                            <label className="text-sm font-medium text-gray-600">Tanggal Perolehan</label>
                            <p className="text-gray-800 flex items-center">
                              <FaCalendar className="mr-2 text-gray-500" />
                              {formatTanggal(inventaris.tgl || "-")}
                            </p>
                          </div>
                        </div>
                        <div className="space-y-3">
                          <div>
                            <label className="text-sm font-medium text-gray-600">Sumber Dana</label>
                            <p className="text-gray-800">{inventaris.sumber_dana_nama || "-"}</p>
                          </div>
                         
                        </div>
                      </div>
                    </div>
                    {/* Riwayat Perbaikan */}
                    <div className="bg-orange-50 rounded-xl p-5">
                      <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                        <FaTools className="mr-2 text-orange-600" />
                        Riwayat Perbaikan Aset
                        <span className="ml-2 bg-orange-200 text-orange-800 text-xs px-2 py-1 rounded-full">
                          {getPerawatan(id).length} Data
                        </span>
                      </h3>
                      <div className="space-y-4">
                        {(() => {
                          const dataPerawatan = getPerawatan(id);
                          const renderedData = renderDataArray(dataPerawatan, "Belum ada riwayat perbaikan untuk aset ini");
                          
                          if (Array.isArray(renderedData)) {
                            return renderedData.map((item, index) => (
                              <div key={index} className="bg-white rounded-lg p-4 border border-orange-200 hover:shadow-md transition-shadow duration-200">
                                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                                  <div>
                                    <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">Masuk</label>
                                    <p className="text-gray-800 font-medium flex items-center mt-1">
                                      <FaCalendar className="mr-2 text-orange-500 text-sm" />
                                      {formatTanggal(item.tgl_masuk)}
                                    </p>
                                  </div>
                                  <div>
                                    <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">Selesai</label>
                                    <p className="text-gray-800 font-medium flex items-center mt-1">
                                      <FaCalendar className="mr-2 text-orange-500 text-sm" />
                                      {formatTanggal(item.tgl_selesai)}
                                    </p>
                                  </div>
                                  <div>
                                    <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">Jenis Kerusakan</label>
                                    <p className="text-gray-800 font-medium mt-1">{item.jenis_kerusakan || "-"}</p>
                                  </div>
                                  <div>
                                    <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">PJ</label>
                                    <p className="text-slate-700 mt-1 text-xs text-wrap">{item.pic}</p>
                                  </div>
                                </div>
                                <div className="mt-3 pt-3 border-t border-orange-100">
                                  <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">Keterangan</label>
                                  <p className="text-gray-700 mt-1 text-sm leading-relaxed">
                                    {item.tindakan || "Tidak ada keterangan"}
                                  </p>
                                </div>
                                {item.petugas_nama && (
                                  <div className="mt-2">
                                    <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">Petugas</label>
                                    <p className="text-gray-700 mt-1 text-sm">{item.petugas_nama}</p>
                                  </div>
                                )}
                              </div>
                            ));
                          }
                          return renderedData;
                        })()}
                      </div>
                    </div>

                    {/* Riwayat Monitoring */}
                    <div className="bg-indigo-50 rounded-xl p-5">
                      <h3 className="text-lg font-semibold text-gray-800 mb-2 flex items-center">
                        <FaClipboardList className="mr-2 text-indigo-600" />
                        Riwayat Monitoring Aset
                        <span className="ml-2 bg-indigo-200 text-indigo-800 text-xs px-2 py-1 rounded-full">
                          {getMonitoring(id).length} Data
                        </span>
                      </h3>
                      <div className="space-y-4">
                        {(() => {
                          const dataMonitoring = getMonitoring(id);
                          const renderedData = renderDataArray(dataMonitoring, "Belum ada riwayat monitoring untuk aset ini");
                          
                          if (Array.isArray(renderedData)) {
                            return renderedData.map((item, index) => {
                              const statusKondisi = getStatusKondisi(item.kondisi);
                              return (
                                <div key={index} className="bg-white rounded-lg p-2 my-1 border border-indigo-200 hover:shadow-md transition-shadow duration-200">
                                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                    <div>
                                      <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">Tanggal Monitoring</label>
                                      <p className="text-gray-800 font-medium flex items-center mt-1">
                                        <FaCalendar className="mr-2 text-indigo-500 text-sm" />
                                        {formatTanggal(item.tgl_mon)}
                                      </p>
                                    </div>
                                    <div>
                                      <div className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium mt-1 ${statusKondisi.bg} ${statusKondisi.color}`}>
                                        {statusKondisi.icon}
                                        <span className="ml-2">{statusKondisi.text}</span>
                                      </div>
                                    </div>
                                    <div>
                                      <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">Petugas</label>
                                      <p className="text-gray-800 font-medium mt-1">{item.pic || "-"}</p>
                                    </div>
                                  </div>
                                  
                                  
                                  {item.lokasi_detail && (
                                    <div className="mt-2">
                                      <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">Detail Lokasi</label>
                                      <p className="text-gray-700 mt-1 text-sm">{item.lokasi_detail}</p>
                                    </div>
                                  )}
                                </div>
                              );
                            });
                          }
                          return renderedData;
                        })()}
                      </div>
                    </div>

                    {/* Informasi Tambahan */}
                   
                  </div>
                ) : (
                  <div className="text-center py-12">
                    <div className="text-gray-400 text-6xl mb-4">
                      <FaEye />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-600 mb-2">
                      Data Tidak Ditemukan
                    </h3>
                    <p className="text-gray-500">
                      Aset dengan ID {id} tidak ditemukan dalam database.
                    </p>
                  </div>
                )}
              </motion.div>

              {/* Footer Modal - Sticky */}
              <div className="bg-gray-50 px-6 py-4 border-t rounded-b-2xl flex-shrink-0">
                <div className="flex justify-between items-center">
                  <p className="text-sm text-gray-500">
                    Scroll untuk melihat informasi lengkap
                  </p>
                  <button
                    onClick={closeDetailModal}
                    className="px-6 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors duration-200 font-medium"
                  >
                    Tutup
                  </button>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}

export default DeatailAset;